import { LiniendatenFilter } from "./LiniendatenFilter";

export default function Liniendaten({vvInstance, statusInstance, zvInstance, ldInstance}) {
    return (
        <div>
            <h1>Liniendaten</h1>
            <LiniendatenFilter vvInstance={vvInstance} statusInstance={statusInstance} zvInstance={zvInstance} ldInstance={ldInstance}/>
        </div>
    )
}